import React from 'react';
import { Helmet } from 'react-helmet';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: 'website' | 'article' | 'product';
  structuredData?: object;
}

export const SEOHead: React.FC<SEOHeadProps> = ({
	title = 'DIYFeed - See it. Shop it. Build it.',
	description = 'Discover DIY projects, shop materials, and build amazing things with DIYFeed. Your one-stop shop for DIY inspiration and supplies.',
	keywords = 'DIY, projects, materials, tools, building, crafts, home improvement, instructions, inspiration',
	image = '/og-image.jpg',
	url = 'https://www.diyfeed.com',
	type = 'website',
	structuredData
}) => {
	const fullTitle = title.includes('DIYFeed') ? title : `${title} | DIYFeed`;
	const fullUrl = url.startsWith('http') ? url : `https://www.diyfeed.com${url}`;
	const fullImage = image.startsWith('http') ? image : `https://www.diyfeed.com${image}`;

	return (
		<Helmet>
			<title>{fullTitle}</title>
			<meta name="description" content={description} />
			<meta name="keywords" content={keywords} />
			<link rel="canonical" href={fullUrl} />
      
			{/* Open Graph */}
			<meta property="og:title" content={fullTitle} />
			<meta property="og:description" content={description} />
			<meta property="og:image" content={fullImage} />
			<meta property="og:url" content={fullUrl} />
			<meta property="og:type" content={type} />
			<meta property="og:site_name" content="DIYFeed" />
      
			{/* Twitter Card */}
			<meta name="twitter:card" content="summary_large_image" />
			<meta name="twitter:title" content={fullTitle} />
			<meta name="twitter:description" content={description} />
			<meta name="twitter:image" content={fullImage} />
      
			{/* Structured Data */}
			{structuredData && (
				<script type="application/ld+json">
					{JSON.stringify(structuredData)}
				</script>
			)}
		</Helmet>
	);
};
